import { getDefaultAccess } from './defaultAccess';

interface IRedirectToMonitor {
  destinationUrl: string;
  unitId?: string;
  target?: '_blank' | '_self';
  placeId?: string;
  roleId?: string;
}

export const redirectToMonitor = ({
  destinationUrl,
  placeId,
  roleId,
}: IRedirectToMonitor) => {
  const accessInfo = getDefaultAccess();
  const place = placeId || getDefaultAccess()?.placeId;
  const baseQueryParams = `PlaceId=${place}&RoleId=${roleId || accessInfo?.roleId}&AppId=7`;
  const queryParams = baseQueryParams;

  const encondedUrl = encodeURIComponent(`${destinationUrl}${queryParams}`);

  const url = process.env.NEXT_PUBLIC_SSO_REDIRECT_TO_MONITOR + encondedUrl;

  return url;
};
